import clsx from "clsx";
import React, { useEffect, useRef } from "react";
import { currentTheme, smetaStore } from "../../../../atoms";
import { Side, SmetaSplitterBarProps } from "./SmetaSplitterConsts";
import styles from "./splitter.module.css";

const collapseSideClassMap = {
  left: styles.expandLeft,
  right: styles.expandRight,
  top: styles.expandTop,
  bottom: styles.expandBottom,
} satisfies Record<Side, string>;

// eslint-disable-next-line @typescript-eslint/naming-convention
const SmetaSplitterBar = (props: SmetaSplitterBarProps) => {
  const theme = smetaStore.get(currentTheme);
  const separatorRef = useRef<HTMLDivElement>(null!);
  const hoverTimeoutRef = useRef<NodeJS.Timeout>(undefined);
  const isHoveredRef = useRef(false);

  useEffect(() => {
    if (props.blockResize) {
      separatorRef.current.setAttribute("block-resize", "");
    } else separatorRef.current.removeAttribute("block-resize");
  }, [props.blockResize]);

  const handleMouseEnter: React.MouseEventHandler<HTMLDivElement> = (ev) => {
    const target = ev.currentTarget;
    isHoveredRef.current = true;
    clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => {
      if (isHoveredRef.current) {
        target.setAttribute("data-active", "");
      }
    }, 200);
  };

  const handleMouseLeave: React.MouseEventHandler<HTMLDivElement> = (ev) => {
    const target = ev.currentTarget;
    isHoveredRef.current = false;
    clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = undefined;
    target.removeAttribute("data-active");
  };

  return (
    <div
      role="separator"
      ref={separatorRef}
      hidden={props.hideSplitter}
      className={clsx(
        styles.splitterBar,
        { [styles.light]: theme === "light" },
        collapseSideClassMap[props.collapseSide],
      )}
      data-primaryelement={props.primaryIndex}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};
export default SmetaSplitterBar;
